import {createFeatureSelector, createSelector} from '@ngrx/store';
import {EState} from 'src/app/state/reducers';
import {EAccountConfirmationStatus, ELoginStatus, IAuthState} from '../models/auth-state.model';

export const selectAuthState = createFeatureSelector<IAuthState>(EState.Auth);
export const selectToken = createSelector(selectAuthState, (state: IAuthState): string => state?.token);
export const selectTokenStatus = createSelector(selectAuthState, (state: IAuthState): ELoginStatus => state?.status);
export const selectAccountConfirmState = createSelector(
  selectAuthState,
  (state: IAuthState): EAccountConfirmationStatus => state?.accountConfirmationStatus
);
export const selectForgotPasswordStatus = createSelector(
  selectAuthState,
  (state: IAuthState): EAccountConfirmationStatus => state?.forgotPasswordStatus
);
export const selectResetPasswordStatus = createSelector(
  selectAuthState,
  (state: IAuthState): EAccountConfirmationStatus => state?.resetPasswordStatus
);
export const selectErrorMessageState = createSelector(
  selectAuthState,
  (state: IAuthState): string => state?.errorMessage
);

export const selectChangePasswordSuccessMessageState = createSelector(
  selectAuthState,
  (state: IAuthState) => state?.changePasswordStatus
);
